import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, Col, Flex, Typography } from 'antd'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'
import { cancelDelete, inProgress, success } from '../../images'

const { Title, Text } = Typography

export const getDisplayStatus = (order) => {
  if (order.cancelled_at) return 'cancelled'
  if (order.delivered_at) return 'delivered'
  if (order.in_progress_at || order.prepared_at || order.ready_to_ship_at || order.with_carrier_at) return 'in_progress'
  return 'new'
}

export const statusTitleKeys = {
  cancelled: 'cardTitleCancelled',
  delivered: 'cardTitleDelivered',
  in_progress: 'cardTitleInProgress',
  new: 'cardTitleNew',
}

export const cardBorderColor = (order) => {
  if (order.cancelled_at) return '#4B4B4B'
  if (order.delivered_at) return '#1677ff'
  return '#53A4F7'
}

const cardIcon = (order) => {
  if (order.cancelled_at) return cancelDelete
  if (order.delivered_at) return success
  return inProgress
}

const DetailDateRow = ({ label, dateStr }) => (
  <Col>
    <Text style={{ color: '#53A4F7', display: 'block', fontSize: 12 }}>{label}</Text>
    <Text>{dayjs(dateStr).format('DD.MM.YYYY')}</Text>
    <Text style={{ display: 'block' }}>{dayjs(dateStr).format('HH:mm')}</Text>
  </Col>
)

DetailDateRow.propTypes = {
  dateStr: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

const OrderDetail = ({ order, onBack }) => {
  const status = getDisplayStatus(order)
  const titleColor = cardBorderColor(order)
  const icon = cardIcon(order)
  const { t } = useTranslation()

  return (
    <Flex vertical>
      <Button onClick={onBack} role="button" style={{ height: 'auto', justifyContent: 'flex-start', marginBottom: 24, marginTop: 12 }} tabIndex={0} type="link">
        <ArrowLeftOutlined style={{ fontSize: 18 }} />
        <Title level={3} style={{ color: '#206AF1', margin: 0 }}><Trans>menuOrders</Trans></Title>
      </Button>

      <Flex className="order-history-card" style={{ alignItems: 'center', alignSelf: 'center', gap: 12 }} vertical>
        <div style={{ paddingBottom: 8 }}>
          <Text strong style={{ color: titleColor, fontSize: 16 }}>{t(statusTitleKeys[status], { quantity: order.tote_quantity })}</Text>
        </div>

        <DetailDateRow
          dateStr={order.cancelled_at || order.delivered_at || order.created_at}
          label={t(order.cancelled_at ? 'cancelledOn' : order.delivered_at ? 'deliveredOn' : 'createdOn')}
        />

        <hr className="separator" />

        <img alt="" src={icon} style={{ height: 70, width: 70 }} />

        {order.tracking_number && (
          <Col>
            <Text style={{ display: 'block' }}>{t('trackingNumber')}</Text>
            <Text strong>{order.tracking_number}</Text>
          </Col>
        )}

        <Col>
          <Text style={{ display: 'block' }}>{t('orderNumber')}</Text>
          <Text strong>{order.order_number}</Text>
        </Col>
      </Flex>
    </Flex>
  )
}

OrderDetail.propTypes = {
  onBack: PropTypes.func.isRequired,
  order: PropTypes.shape({
    cancelled_at: PropTypes.string,
    created_at: PropTypes.string,
    delivered_at: PropTypes.string,
    order_number: PropTypes.string,
    tote_quantity: PropTypes.number,
    tracking_number: PropTypes.string,
  }).isRequired,
}

export default OrderDetail
